import { render } from "./BaseButton.html?vue&type=template&id=5e1feb08&scoped=true&ts=true&external"
import script from "./BaseButton.vue?vue&type=script&lang=ts"
export * from "./BaseButton.vue?vue&type=script&lang=ts"

import "./BaseButton.scss?vue&type=style&index=0&id=5e1feb08&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1feb08"]])

export default __exports__